

export const ROLE_GENERAL = ['GENERAL']

export const ROLE_DRAFTER = ['GENERAL', 'DRAFTER']

export const ROLE_CHEMENG = ['GENERAL', 'CHEMENG']